import type { FormerMemberDto } from '@werft/contracts';
import { t } from '../i18n/index.js';

/**
 * Frühere Mitglieder und Gäste (P21): ihre Namen bleiben als Schnappschuss lesbar – an Kommentaren, Beiträgen,
 * Versionen. Jede Namensanzeige fällt über `nameOr` hierauf zurück statt auf „Unbekannt“.
 */
const former = new Map<string, FormerMemberDto>();

export function rememberFormer(list: FormerMemberDto[] | undefined) {
  for (const f of list ?? []) former.set(f.userId, f);
}

/** Name aus der aktuellen Mitgliederliste, sonst Schnappschuss („… (ehemals Gast)“), sonst „Unbekannt“ */
export function nameOr(names: ReadonlyMap<string, string>, id: string | null | undefined): string {
  if (id && names.has(id)) return names.get(id)!;
  // P22: über einen Freigabelink mitgeschrieben
  if (id?.startsWith('~')) return t('former.link', { name: id.slice(1) });
  const f = id ? former.get(id) : undefined;
  return f ? t(f.guest ? 'former.guest' : 'former.member', { name: f.name }) : t('comment.unknown');
}
